export default "__VITE_ASSET__D5YMvIia__"